// extracted by mini-css-extract-plugin
module.exports = {"row":"CouponsTable_row__1RdHO"};